import ConfirmationModal from 'components/modals/confirmation/ConfirmationModal';
import { useModal } from 'components/modals/useModal';
import { useDeleteExpenseMutation } from 'store/api/expenses';
import { errorAlert } from 'utils/alert';
import { t } from 'utils/getTranslations';
import { useLeaveDeletedEntity } from 'utils/useNavigateWithReturnState';

/** Delete with its confirmation, then away from the deleted expense: the edit form's and the record header's. */
export const useConfirmDeleteExpense = (): ((expenseId: number) => void) => {
    const { openModal, closeModal } = useModal();
    const [deleteExpense] = useDeleteExpenseMutation();
    const leaveDeleted = useLeaveDeletedEntity('/expenses');

    return (expenseId: number) =>
        openModal(
            <ConfirmationModal
                onCancel={closeModal}
                onConfirm={() => {
                    void deleteExpense({ id: expenseId })
                        .unwrap()
                        .then(leaveDeleted)
                        .catch((e) => {
                            console.error(e);
                            errorAlert(t('forms.error-submitting-the-form'));
                        })
                        .finally(() => closeModal());
                }}
                content={<p className="text-body1">{t('expenses.delete-confirmation-text')}</p>}
            />
        );
};
